"use strict";

exports.__esModule = true;
exports.withFinalForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Provides access to final form via a HOC.
 */
var withFinalForm = exports.withFinalForm = function withFinalForm(component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FormSpy, _extends({}, props, {
      component: component
    }));
  };
};